const LS_KEY = 'alumni-v2-login-attempt';

export const setAuthData = (questionId) => {
  localStorage.setItem(LS_KEY, questionId);
};

export const getAuthData = () => localStorage.getItem(LS_KEY);

export const removeAuthData = () => {
  localStorage.removeItem(LS_KEY);
};

export const isUserLoggedIn = () => window.__INITIAL_STATE__.currentUser;


export const setAuthPathAttribute = (proccedPath) => {
  const authButton = document.getElementsByClassName(
    'alumni-v2-auth-trigger',
  )[0];

  if (!authButton) return;

  authButton.setAttribute('data-proceed', proccedPath);
};

export const authTrigger = () => {
  document.getElementsByClassName('alumni-v2-auth-trigger')[0].click();
};


export const showReviewPageRevamp = () => window.__INITIAL_STATE__
  .showReviewPageRevamp === 'true';
